import { SendStoreLocatorForm } from "@/interfaces";
import axios from "axios";

class FormService {
    constructor() { }

    async send(body: SendStoreLocatorForm): Promise<void> {
        await axios.post('/frontend/send-dealer', body);
    }
}

export default new FormService();